import { ENDPOINTS, endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const getAllCreators = (params) => {
  const url = ENDPOINTS.CREATOR.GET_ALL;
  const queryParams = new URLSearchParams();
  if (params?.page) queryParams.append("page", params.page);
  if (params?.limit) queryParams.append("limit", params.limit);
  if (params?.search) queryParams.append("search", params.search);

  const finalUrl = queryParams.toString()
    ? `${url}?${queryParams.toString()}`
    : url;

  return Api(finalUrl, null, requestType.GET);
};

const updateCreatorOnboardingStatus = (id, params) => {
  return Api(
    ENDPOINTS.CREATOR.UPDATE_ONBOARDING_STATUS.replace(":id", id),
    params,
    requestType.PUT
  );
};

const updateCreatorAccountStatus = (id, params) => {
  return Api(ENDPOINTS.CREATOR.UPDATE_ACCOUNT_STATUS.replace(":id", id), params, requestType.PUT);
};

export {
  getAllCreators,
  updateCreatorOnboardingStatus,
  updateCreatorAccountStatus,
};
